let DateFormat = {
    /**
     * 返回yyyy-MM-dd
     * @param date
     * @returns {string}
     */
    dateFormat(date) {
        let now = new Date(date);
        let yy = now.getFullYear();
        let mm = (now.getMonth() + 1) >= 10 ? (now.getMonth() + 1) : '0' + (now.getMonth() + 1);
        let dd = now.getDate() >= 10 ? now.getDate() : '0' + now.getDate();
        return yy + '-' + mm + '-' + dd;
    },
    /**
     * 返回yyyy-MM-dd HH:mm:ss
     * @param time
     * @returns {string}
     */
    dateFormatTime(time) {
        let date = new Date(time)
        let y = date.getFullYear()
        let m = date.getMonth() + 1 >= 10 ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1);
        let d = date.getDate() >= 10 ? date.getDate() : '0' + date.getDate();

        let hh = date.getHours() >= 10 ? date.getHours() : '0' + date.getHours();
        let mm = date.getMinutes() >= 10 ? date.getMinutes() : '0' + date.getMinutes();
        let ss = date.getSeconds() >= 10 ? date.getSeconds() : '0' + date.getSeconds();
        return y + '-' + m + '-' + d + ' ' + hh + ':' + mm + ':' + ss;
    }
};
export {DateFormat}
